import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/** Largura máxima e margens laterais padrão do site. */
export function Container({ className, children }: { className?: string; children: ReactNode }) {
  return <div className={cn('mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8', className)}>{children}</div>
}

/** Cabeçalho de página: sobretítulo opcional, título, descrição e ações. */
export function PageHeader({
  eyebrow,
  title,
  description,
  actions,
  className,
}: {
  eyebrow?: ReactNode
  title: ReactNode
  description?: ReactNode
  actions?: ReactNode
  className?: string
}) {
  return (
    <header className={cn('flex flex-col gap-4 border-b border-border pb-8 sm:flex-row sm:items-end sm:justify-between', className)}>
      <div className="max-w-3xl space-y-3">
        {eyebrow ? <div className="text-sm font-medium text-muted-foreground">{eyebrow}</div> : null}
        <h1 className="text-3xl font-semibold leading-tight tracking-tight sm:text-4xl">{title}</h1>
        {description ? <div className="text-lg leading-relaxed text-muted-foreground">{description}</div> : null}
      </div>
      {actions ? <div className="flex shrink-0 flex-wrap gap-2">{actions}</div> : null}
    </header>
  )
}

/** Seção com título discreto. */
export function Section({
  title,
  description,
  actions,
  children,
  className,
  id,
}: {
  title?: ReactNode
  description?: ReactNode
  actions?: ReactNode
  children: ReactNode
  className?: string
  id?: string
}) {
  return (
    <section id={id} className={cn('space-y-5', className)} aria-labelledby={id && title ? `${id}-titulo` : undefined}>
      {title || actions ? (
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div className="space-y-1">
            {title ? (
              <h2 id={id ? `${id}-titulo` : undefined} className="text-xl font-semibold tracking-tight">
                {title}
              </h2>
            ) : null}
            {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
          </div>
          {actions}
        </div>
      ) : null}
      {children}
    </section>
  )
}
